(function(){
function init(root){
  if(!root||root.dataset.ready)return;root.dataset.ready='1';
  var de=root.querySelector('[data-pf-data]'),data={};
  try{data=JSON.parse(de.textContent)}catch(e){}
  /* filters */
  var btns=root.querySelectorAll('[data-f]'),ct=root.querySelector('[data-count]');
  var cards=[].slice.call(root.querySelectorAll('.pfr'));
  function layout(){
    var j=0;cards.forEach(function(c){if(!c.classList.contains('is-hid')){c.classList.toggle('rev',j%2===1);j++}});
  }
  function filt(f){
    var n=0;
    cards.forEach(function(c){
      var ok=f==='all'||(' '+c.getAttribute('data-cat')+' ').indexOf(' '+f+' ')>-1;
      c.classList.toggle('is-hid',!ok);if(ok)n++;
    });
    if(ct)ct.textContent=n+(n===1?' project':' projects');
    layout();
  }
  btns.forEach(function(b){b.addEventListener('click',function(){
    btns.forEach(function(x){x.classList.toggle('on',x===b);x.setAttribute('aria-pressed',x===b?'true':'false')});
    filt(b.getAttribute('data-f'));
  })});
  layout();
  /* lightbox */
  var lb=root.querySelector('[data-lb]');if(!lb)return;
  document.querySelectorAll('body > .wlb').forEach(function(o){o.remove()});
  document.body.appendChild(lb);
  var im=lb.querySelector('[data-lb-i]'),tt=lb.querySelector('[data-lb-t]'),cc=lb.querySelector('[data-lb-c]'),rail=lb.querySelector('[data-lb-r]');
  var cur=null,idx=0,last=null;
  function pad(x){return x<10?'0'+x:''+x}
  function show(){
    var src=cur.i[idx];im.classList.add('ld');
    var pre=new Image();pre.onload=function(){if(cur&&cur.i[idx]===src){im.src=src;im.classList.remove('ld')}};pre.src=src;
    cc.textContent=pad(idx+1)+' / '+pad(cur.i.length);
    var bs=rail.children;for(var j=0;j<bs.length;j++){bs[j].classList.toggle('on',j===idx)}
    if(bs[idx])bs[idx].scrollIntoView({block:'nearest',inline:'center'});
    [idx+1,idx-1].forEach(function(j){if(j>=0&&j<cur.i.length){var p=new Image();p.src=cur.i[j]}});
  }
  function open(k,i){
    cur=data[k];if(!cur||!cur.i.length)return;idx=Math.min(i||0,cur.i.length-1);last=document.activeElement;
    tt.textContent=cur.t;rail.innerHTML='';
    cur.s.forEach(function(s,j){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Photo '+(j+1));b.innerHTML='<img alt="" loading="lazy">';b.firstChild.src=s;b.addEventListener('click',function(){idx=j;show()});rail.appendChild(b)});
    rail.style.display=cur.i.length>1?'':'none';
    lb.querySelectorAll('.wlbn').forEach(function(b){b.style.visibility=cur.i.length>1?'':'hidden'});
    lb.classList.add('on');lb.setAttribute('aria-hidden','false');document.documentElement.classList.add('wlb-on');
    show();lb.querySelector('[data-lb-x]').focus();
  }
  function close(){lb.classList.remove('on');lb.setAttribute('aria-hidden','true');document.documentElement.classList.remove('wlb-on');cur=null;if(last&&last.focus)last.focus()}
  function go(d){if(!cur)return;idx=(idx+d+cur.i.length)%cur.i.length;show()}
  root.querySelectorAll('[data-open]').forEach(function(el){
    function h(e){if(e.type==='keydown'&&e.key!=='Enter'&&e.key!==' ')return;e.preventDefault();e.stopPropagation();open(el.getAttribute('data-open'),+el.getAttribute('data-i')||0)}
    el.addEventListener('click',h);if(el.tagName!=='BUTTON')el.addEventListener('keydown',h);
  });
  lb.querySelector('[data-lb-x]').addEventListener('click',close);
  lb.querySelector('[data-lb-p]').addEventListener('click',function(){go(-1)});
  lb.querySelector('[data-lb-n]').addEventListener('click',function(){go(1)});
  lb.querySelector('.wlbs').addEventListener('click',function(e){if(e.target===e.currentTarget)close()});
  document.addEventListener('keydown',function(e){if(!cur)return;if(e.key==='Escape')close();else if(e.key==='ArrowRight')go(1);else if(e.key==='ArrowLeft')go(-1)});
  var x0=null;
  lb.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
  lb.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(dx<0?1:-1);x0=null},{passive:true});
}
function all(){document.querySelectorAll('[data-pf]').forEach(init)}
if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
document.addEventListener('shopify:section:load',all);
})();